module.exports = __webpack_public_path__ + "static/media/bg_pt-marcus_kontakt.9c1228b3.png";